export default __webpack_public_path__ + "static/media/studyMaterial.24b6c204.svg";